import CitySEOHead from "@/components/feature/CitySEOHead";
import AlpharettaHeroSection from "./components/HeroSection";
import AlpharettaStickyNav from "./components/StickyNav";
import AlpharettaProcessingTimeSection from "./components/ProcessingTimeSection";
import AlpharettaServicesSection from "./components/ServicesSection";
import AlpharettaLocalAreaSection from "./components/LocalAreaSection";
import AlpharettaTestimonialsSection from "./components/TestimonialsSection";
import AlpharettaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AlpharettaComparisonSection from "./components/ComparisonSection";
import AlpharettaMistakesSection from "./components/MistakesSection";
import AlpharettaHowItWorksSection from "./components/HowItWorksSection";
import AlpharettaFAQSection, { faqs } from "./components/FAQSection";
import AlpharettaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AlpharettaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const alpharettaFaqs = faqs as { q: string; a: string }[];

const alpharettaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function AlpharettaPage() {
  return (
    <>
      <CitySEOHead
        city="Alpharetta"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/alpharetta"
        title="Emergency Passport Alpharetta, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Alpharetta, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving north metro Atlanta travelers. Get your emergency passport fast!"
        geoPlacename="Alpharetta, Georgia"
        geoPosition="34.0754;-84.2941"
        faqs={alpharettaFaqs}
        servicesSchema={alpharettaServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Alpharetta passport, same day passport Atlanta, fast passport Georgia"
      />
      <div className="font-sans">
        <AlpharettaHeroSection />
        <AlpharettaStickyNav />
        <AlpharettaProcessingTimeSection />
        <AlpharettaServicesSection />
        <AlpharettaLocalAreaSection />
        <AlpharettaTestimonialsSection />
        <AlpharettaAcceptanceFacilitiesSection />
        <AlpharettaComparisonSection />
        <AlpharettaMistakesSection />
        <AlpharettaHowItWorksSection />
        <AlpharettaFAQSection />
        <AlpharettaHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/alpharetta" state="GA" />
        <AlpharettaFinalCTA />
      </div>
    </>
  );
}